var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',[_c('div',{staticClass:"tab-content"},[(_vm.current_user.permissions.length > 0)?_c('div',{staticClass:"tab-pane active",attrs:{"id":"user-list"}},[_c('notification-filter',{attrs:{"action":_vm.filterAction}}),_c('kt-datatable',_vm._b({ref:"datatable"},'kt-datatable',_vm.datatableProps,false))],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }